import React, { useEffect, useState, useContext } from "react";
import { Container } from "react-bootstrap";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import "../../../assets/css/customer/dashboard/MyDeals.css";
import { useNavigate } from "react-router-dom";
import { checkLoggedInCustomer } from "../../../helper/CustomHelper";

const MyDeals = () => {
  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);
  const [deals, setDeals] = useState([]);

  // const viewAllClaimedDeals = () => {
  //   axios
  //     .get(`${baseUrl}/customer/appointment/viewAllDeals`)
  //     .then((response) => {
  //         console.log("DATA:", response.data);
  //       const data =
  //         response.data?.deals ||
  //         response.data?.data ||
  //         response.data;
  //       setDeals(Array.isArray(data) ? data : []);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setDeals([]);
  //     });
  // };
const viewAllClaimedDeals = () => {
  const escustomerId = localStorage.getItem("customerId");

  axios
    .get(`${baseUrl}/customer/appointment/viewMyDeals`, {
      params: { escustomer_id: escustomerId },
    })
    .then((response) => {
      const data =
        response.data?.deals ||
        response.data?.data ||
        response.data;
      setDeals(Array.isArray(data) ? data : []);
    })
    .catch((error) => {
      console.log(error);
      setDeals([]);
    });
};
  useEffect(() => {
    checkLoggedInCustomer(navigate);
    viewAllClaimedDeals();
  }, []);

  return (
    <div className="sgc-deal-page">
      <Container fluid>
        <h1 className="sgc-deal-title">My Deals</h1>

        {deals.length === 0 && (
          <p className="sgc-deal-empty">No claimed deals yet.</p>
        )}

        {deals.map((item) => {
          // deal ka data esdeal ke andar hai
          const deal = item.esdeal || {};
          return (
            <div className="sgc-deal-card" key={item.id}>

              {/* Left: discount box */}
              <div className="sgc-deal-thumb-wrap">
                {deal.tag && (
                  <span className="sgc-deal-thumb-badge">{deal.tag}</span>
                )}
                <div className="sgc-deal-thumb-discount">
                  {deal.discount || "—"}
                </div>
              </div>

              {/* Right: info */}
              <div className="sgc-deal-info">
                <p className="sgc-deal-name">{deal.title || "Deal"}</p>
                <p className="sgc-deal-meta">
                  📅 {item.appointment_date} &nbsp;|&nbsp; 🕐 {item.appointment_time}
                </p>
                {deal.description && (
                  <p className="sgc-deal-desc">{deal.description}</p>
                )}
              </div>

              {/* Status badge */}
              <div className="sgc-deal-status-wrap">
                <span className={`sgc-deal-badge sgc-deal-badge-${(item.status || "pending").toLowerCase()}`}>
                  {item.status || "Pending"}
                </span>
              </div>

            </div>
          );
        })}
      </Container>
    </div>
  );
};

export default MyDeals;